import { ActionSuggestion, ActionType } from '../model'
import { useSyncStatuses } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/hooks'

const useSyncStatusForActionType = (actionType: ActionType) => {
  const { meetingSummarySyncStatus, taskSyncStatuses, contactUpdateSyncStatus } = useSyncStatuses()

  switch (actionType) {
    case 'exportMeeting':
      return meetingSummarySyncStatus
    case 'createTask':
      return taskSyncStatuses
    case 'updateContact':
      return contactUpdateSyncStatus
    default:
      return []
  }
}

const actionTypeToSyncTypeMap: Record<ActionType, string> = {
  exportMeeting: 'meetingSummary',
  createTask: 'task',
  updateContact: 'updateContact',
}

export const useFilterSuggestions = (suggestions: ActionSuggestion[], actionType: ActionType): ActionSuggestion[] => {
  const syncStatuses = useSyncStatusForActionType(actionType)

  return suggestions.filter((action) => {
    const syncType = actionTypeToSyncTypeMap[actionType]
    const syncStatus = syncStatuses.find((status) => status.type === syncType && status.serviceId === action.serviceId)
    return !syncStatus
  })
}
